import { images } from '../../constants';

const abouts = [
  {
    id: 1,
    title: 'Backend Development',
    description: 'I develop well thought out backend scalable logic using Rails.',
    imgUrl: images.backend,
  },
  {
    id: 2,
    title: 'Rails API',
    description: 'I create Rails API and expose endpoint that can be rendered on multiple frontends.',
    imgUrl: images.railsApi,
  },
  {
    id: 3,
    title: 'Frontend Development',
    description: 'I create awesome React and Redux frontend Apps that can be rendered on multiple backends.',
    imgUrl: images.frontend,
  },
  {
    id: 4,
    title: 'Full-stack Web Development',
    description: 'I develop full apps that merge several technologies in both Front and Back end.',
    imgUrl: images.fullstack,
  },
];

export default abouts;
